import React,{useState,useEffect} from 'react';
import {addToken} from '../../store/actions/token';
import {connect} from 'react-redux';
import {useHistory} from 'react-router-dom';
import {GetCookie,CreateCookie} from '../../Utils';

const Login = ({tokenObject,addToken,connection}) => {

    const [Email,setEmail] = useState("");
    const [Pass,setPass] = useState("");
    const [wasFailed,setWasFailed] = useState("");
    let history = useHistory();

    useEffect(() => {
        if(GetCookie('token') !== undefined){
            addToken(GetCookie('token'));
            history.push('/Contents');
        }
    });

    async function login(){
        
        if(Email === ""){
            setWasFailed("O E-mail inserido é inválido");
            return;
        }

        if(Pass === ""){
            setWasFailed("Insira uma senha")
        }


        const result = await connection.post("/login",{
            Email:Email,
            Password:Pass
        });

        if(result.status !== 200){
            setWasFailed("Algo deu errado, tente novamente mais tarde...");
            return;
        }

        addToken(result.data.token);
        CreateCookie(result.data.token);
        setWasFailed("");

        history.push('/Contents');
    }

    function handleAddEmail(EmailInput){
        setEmail(EmailInput.target.value);
    }

    function handleAddPass(PassInput){
        setPass(PassInput.target.value);
    }

    return(
        <div>
            <br/>
            {(
                function(){
                    return (wasFailed !== "") ? (
                    <div class="alert alert-danger" role="alert">
                        {wasFailed}
                   </div>) : (<></>);
                }
            )()}
            <center><h1>Log in</h1></center>

                <div className="mb-3">
                    <label htmlFor="exampleInputEmail1" className="form-label">Email address</label>
                    <input type="email" className="form-control" id="exampleInputEmail1" aria-describedby="emailHelp" onKeyUp={handleAddEmail}/>
                    <div id="emailHelp" className="form-text">We'll never share your email with anyone else.</div>
                </div>
                <div className="mb-3">
                    <label htmlFor="exampleInputPassword1" className="form-label">Password</label>
                    <input type="password" className="form-control" id="exampleInputPassword1" onKeyUp={handleAddPass}/>
                </div>
                <button className="btn btn-primary" onClick={login}>Submit</button>

        </div>
    )
};

const mapStateToProps = (state) => ({
    tokenObject: state.token
});

export default connect(mapStateToProps,{addToken})(Login);